import React from "react";
import { Form, InputGroup, OverlayTrigger, Tooltip, Tabs, Tab } from "react-bootstrap";
import { BsArrowCounterclockwise, BsFilter } from "react-icons/bs";
import { FaFileContract, FaIdCard, FaTruck, FaBoxes, FaCalendarAlt } from "react-icons/fa";
import ExportReportDropdown from "./ExportReportDropdown";
import DashMedidasSectionCard from "../../DashMedidas/components/DashMedidasSectionCard/DashMedidasSectionCard";
import DashMedidasButton, {
  DashMedidasButtonGroup,
} from "../../DashMedidas/components/DashMedidasButton/DashMedidasButton";

const Filter = ({
  user,
  allData,
  handleGetPeriod,
  setStartDate,
  setEndDate,
  ultimoClicado,
  filterData,
  lastData,
  startDate,
  endDate,
  handledata,
  permissionSGU,
  handleClearFilters,
  hasActiveFilters = false,
  customFilter,
  setCustomFilter,
  embedded = false,
  equipmentOptions = [],
  selectedUnitsCount = 0,
  hours = {},
  curvaSelecionada = "",
  onPdfError,
}) => {
  const handleChangeStartDate = (event) => {
    setStartDate(event.target.value);
  };

  const handleChangeEndDate = (event) => {
    setEndDate(event.target.value);
  };

  function diasNosMeses(meses) {
    const hoje = new Date();
    const dataAtras = new Date(hoje.getFullYear(), hoje.getMonth() - meses, hoje.getDate());
    const diferencaEmMilissegundos = hoje - dataAtras;
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
    return diferencaEmDias.toFixed(0) - 1;
  }

  const quantidadeDeDiasUmMes = diasNosMeses(1);
  const quantidadeDeDiasTresMeses = diasNosMeses(3);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomFilter((prevFilter) => ({ ...prevFilter, [name]: value }));
  };

  const handleApplyFilters = () => {
    handleGetPeriod(lastData, ultimoClicado, filterData, customFilter);
  };

  const handlePeriodClick = (days, ultimoClicadoIndex) => {
    handleGetPeriod(days, ultimoClicadoIndex, filterData, customFilter);
  };

  const hasAdvancedFilterDraft = Object.values(customFilter || {}).some((value) =>
    String(value).trim()
  );

  const filtersAreActive = hasActiveFilters || hasAdvancedFilterDraft;
  const canWrite = permissionSGU?.report?.write;

  const onClearFilters = () => {
    if (typeof handleClearFilters === "function") {
      handleClearFilters();
    }
  };

  const headerRight = (
    <div className="relatorios-filtros-header-right">
      {allData?.length ? (
        <span className="dash-section-card__header-meta">
          {allData.length} registro{allData.length !== 1 ? "s" : ""}
        </span>
      ) : null}
      <DashMedidasButton
        variant={filtersAreActive ? "outline-danger" : "light"}
        onClick={onClearFilters}
        disabled={!canWrite || !filtersAreActive}
        className={!filtersAreActive ? "dash-btn--muted" : ""}
        title="Limpar filtros"
      >
        <BsArrowCounterclockwise /> Limpar
      </DashMedidasButton>
      <ExportReportDropdown
        user={user}
        permissionSGU={permissionSGU}
        allData={allData}
        equipmentOptions={equipmentOptions}
        selectedUnitsCount={selectedUnitsCount}
        startDate={startDate}
        endDate={endDate}
        ultimoClicado={ultimoClicado}
        lastData={lastData}
        filterData={filterData}
        customFilter={customFilter}
        hours={hours}
        curvaSelecionada={curvaSelecionada}
        fileName="Relatório Unidades"
        onError={onPdfError}
      />
    </div>
  );

  return (
    <DashMedidasSectionCard
      icon={BsFilter}
      subtitle="Consulta"
      title="Filtros"
      headerRight={headerRight}
      collapsible={!embedded}
      sectionId="relatorios-filtros"
      className="relatorios-filtros-card"
      asPanel={embedded}
      panelClassName={embedded ? "relatorios-filtros-panel-card" : ""}
      bodyClassName="relatorios-filtros-body"
    >
      <div className="dash-section-card__content-stack relatorios-filtros-stack">
        <Tabs defaultActiveKey="period" className="dash-medidas-tabs relatorios-filtros-tabs" variant="pills">
          <Tab
            eventKey="period"
            title={
              <span className="dash-medidas-tab-label">
                <FaCalendarAlt className="dash-medidas-tab-icon" aria-hidden />
                Período
              </span>
            }
          >
            <div className="dash-filtros-tab-panel dash-filtros-tab-panel--period relatorios-filtros-panel">
              <div className="dash-filtros-period-toolbar d-flex gap-2 flex-wrap align-items-center">
                <div className="dash-filtros-period-groups d-flex flex-wrap gap-1 align-items-center">
                  <DashMedidasButtonGroup className="dash-btn-group--responsive">
                    <DashMedidasButton
                      onClick={() => handlePeriodClick(1, 0)}
                      variant={ultimoClicado === 0 ? "success" : "outline-success"}
                      disabled={!canWrite}
                    >
                      1 dia
                    </DashMedidasButton>
                    <DashMedidasButton
                      onClick={() => handlePeriodClick(7, 1)}
                      variant={ultimoClicado === 1 ? "success" : "outline-success"}
                      disabled={!canWrite}
                    >
                      7 dias
                    </DashMedidasButton>
                    <DashMedidasButton
                      onClick={() => handlePeriodClick(quantidadeDeDiasUmMes, 2)}
                      variant={ultimoClicado === 2 ? "success" : "outline-success"}
                      disabled={!canWrite}
                    >
                      1 mês
                    </DashMedidasButton>
                    <DashMedidasButton
                      onClick={() => handlePeriodClick(quantidadeDeDiasTresMeses, 3)}
                      variant={ultimoClicado === 3 ? "success" : "outline-success"}
                      disabled={!canWrite}
                    >
                      3 meses
                    </DashMedidasButton>
                  </DashMedidasButtonGroup>

                  <DashMedidasButtonGroup className="dash-btn-group--responsive dash-filtros-type-group">
                    <OverlayTrigger placement="top" overlay={<Tooltip>Mostrar todos os registros</Tooltip>}>
                      <DashMedidasButton
                        onClick={() => handleGetPeriod(lastData, ultimoClicado, "all", customFilter)}
                        variant={filterData === "all" ? "secondary" : "outline-secondary"}
                        disabled={!canWrite}
                      >
                        Tudo
                      </DashMedidasButton>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Filtrar entradas (umidade &gt; 14%)</Tooltip>}
                    >
                      <DashMedidasButton
                        onClick={() => handleGetPeriod(lastData, ultimoClicado, "input", customFilter)}
                        variant={filterData === "input" ? "secondary" : "outline-secondary"}
                        disabled={!canWrite}
                      >
                        Entradas
                      </DashMedidasButton>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Filtrar saídas (umidade &lt; 13,5%)</Tooltip>}
                    >
                      <DashMedidasButton
                        onClick={() => handleGetPeriod(lastData, ultimoClicado, "output", customFilter)}
                        variant={filterData === "output" ? "secondary" : "outline-secondary"}
                        disabled={!canWrite}
                      >
                        Saídas
                      </DashMedidasButton>
                    </OverlayTrigger>
                  </DashMedidasButtonGroup>
                </div>

                <div className="dash-filtros-date-range d-flex flex-nowrap gap-1 align-items-center">
                  <InputGroup size="sm" className="dash-date-input">
                    <InputGroup.Text className="py-0 bg-light">De</InputGroup.Text>
                    <Form.Control
                      type="date"
                      size="sm"
                      value={startDate ? startDate.slice(0, 10) : ""}
                      onChange={handleChangeStartDate}
                      disabled={!canWrite}
                      className="text-success"
                    />
                  </InputGroup>
                  <InputGroup size="sm" className="dash-date-input">
                    <InputGroup.Text className="py-0 bg-light">Até</InputGroup.Text>
                    <Form.Control
                      type="date"
                      size="sm"
                      value={endDate ? endDate.slice(0, 10) : ""}
                      onChange={handleChangeEndDate}
                      disabled={!canWrite}
                      className="text-success"
                    />
                  </InputGroup>
                  <DashMedidasButton
                    onClick={handledata}
                    variant="success"
                    disabled={!canWrite}
                  >
                    Buscar
                  </DashMedidasButton>
                </div>
              </div>
            </div>
          </Tab>

          <Tab
            eventKey="advanced"
            title={
              <span className="dash-medidas-tab-label">
                <BsFilter className="dash-medidas-tab-icon" aria-hidden />
                Avançado
                {hasAdvancedFilterDraft && (
                  <span className="dash-medidas-tab-badge" aria-hidden />
                )}
              </span>
            }
          >
            <div className="dash-filtros-tab-panel dash-filtros-tab-panel--advanced relatorios-filtros-panel">
              <div className="dash-filtros-advanced d-flex gap-1 flex-wrap align-items-center">
                <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                  <InputGroup.Text className="py-0 bg-light text-secondary">
                    <FaFileContract size={14} />
                  </InputGroup.Text>
                  <Form.Control
                    size="sm"
                    type="text"
                    name="contrato"
                    value={customFilter.contrato}
                    onChange={handleInputChange}
                    placeholder="Contrato"
                  />
                </InputGroup>
                <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                  <InputGroup.Text className="py-0 bg-light text-secondary">
                    <FaIdCard size={14} />
                  </InputGroup.Text>
                  <Form.Control
                    size="sm"
                    type="text"
                    name="cnpj"
                    value={customFilter.cnpj}
                    onChange={handleInputChange}
                    placeholder="CNPJ"
                  />
                </InputGroup>
                <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                  <InputGroup.Text className="py-0 bg-light text-secondary">
                    <FaBoxes size={14} />
                  </InputGroup.Text>
                  <Form.Control
                    size="sm"
                    type="text"
                    name="lote"
                    value={customFilter.lote}
                    onChange={handleInputChange}
                    placeholder="Lote"
                  />
                </InputGroup>
                <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                  <InputGroup.Text className="py-0 bg-light text-secondary">
                    <FaTruck size={14} />
                  </InputGroup.Text>
                  <Form.Control
                    size="sm"
                    type="text"
                    name="placa"
                    value={customFilter.placa}
                    onChange={handleInputChange}
                    placeholder="Placa"
                  />
                </InputGroup>
                <DashMedidasButton variant="success" onClick={handleApplyFilters} disabled={!canWrite}>
                  Aplicar
                </DashMedidasButton>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </DashMedidasSectionCard>
  );
};

export default Filter;
